import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/recargas',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteRecargasPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Recargas</PageTitle>
      <View />
    </>
  );
};

export { ReporteRecargasPage };
